<template>
    <div>
        <div class="col-sm-12 text-right">
            <div class="input-group">
                <input
                id="search"
                type="text"
                class="form-control"
                v-model="searchKey"
                placeholder="domainname.com"
                aria-describedby="search"
                />
                <div class="input-group-prepend">
                <button
                    id="search"
                    class="input-group-text bg-primary text-white"
                    @click="searchWebsite"
                >
                    <i class="bx bx-search-alt search-icon"></i>
                </button>
                </div>
            </div>
        </div>
            <div v-if="loading" class=" mt-4 mx-auto">
                <div class="text-center">
                    <!-- <i class="bx bx-loader bx-lg bx-bx-world align-middle mr-2"></i>  -->
                        <div class="spinner-border text-secondary" role="status" v-if="loading">
                    <span class="sr-only"><p>{{ $t('website.website-info') }}</p></span>
                    </div>
                </div>
            </div>
            <div>
        <div class="row mt-4" v-if="SearchResult">
            <!-- <p>
            {{SearchResult}}
            </p> -->
            <div class="col-sm-12 px-4" >
                    <p v-if="SearchResult.visitors"><b>{{ $t('website.visitors') }}: </b> {{SearchResult.visitors}}</p>
                    <p v-if="SearchResult.ip_address"><b>{{ $t('website.ip') }}: </b> {{SearchResult.ip_address}}</p>
                    <p v-if="SearchResult.link_ipv6_address"><b>{{ $t('website.visitors') }}: </b> {{SearchResult.link_ipv6_address}}</p>
                    <p v-if="SearchResult.ip_location"><b>{{ $t('website.ip_location') }}: </b> {{SearchResult.ip_location}}</p>
                    <p v-if="SearchResult.ip_reverse_dns"><b>{{ $t('website.ip_reserve_dns') }}: </b> {{SearchResult.ip_reverse_dns}}</p>
                    <p v-if="SearchResult.hosting_company"><b>{{ $t('website.hosting_company') }}: </b> {{SearchResult.hosting_company}}</p>
                    <p v-if="SearchResult.hosting_ip_range"><b>{{ $t('website.hosting_ip_range') }}: </b> {{SearchResult.hosting_ip_range}}</p>
                    <p v-if="SearchResult.hosting_address"><b>{{ $t('website.hosting_address') }}: </b> {{SearchResult.hosting_address}}</p>
                    <p v-if="SearchResult.hosting_country"><b>{{ $t('website.hosting_country') }}: </b> {{SearchResult.hosting_country}}</p>
                    <p v-if="SearchResult.hosting_phone"><b>{{ $t('website.hosting_phone') }}: </b> {{SearchResult.hosting_phone}}</p>
                    <p v-if="SearchResult.cidr"><b>{{ $t('website.cidr') }}: </b> {{SearchResult.cidr}}</p>
                    <p v-if="SearchResult.hosting_cidr"><b>{{ $t('website.hosting_cidr') }}: </b> {{SearchResult.hosting_cidr}}</p>
            </div>
                <div class="col-sm-12 text-right" v-if="SearchResult">
                    <b-button class="btn" variant="secondary" size="sm" @click="clearData"><i class="fa fa-times"></i> Clear</b-button> <b-button class="btn" variant="success" size="sm" @click="saveWebsiteInfo"><i class="fa fa-check"></i> Save</b-button>
                </div>
        </div>
    </div>
    </div>
</template>

<script>
import Vue from "vue";
import appConfig from "@/app.config";
import moment from 'moment';
import WebsiteService from "@/helpers/website.service.js";
import Swal from "sweetalert2";

export default {
    props: ['id_target'],
    page: {
        title: "Tools Website",
        meta: [{ name: "description", content: appConfig.description }]
    },
    data() {
        return {
            id: this.id_target,
            urlimage: 'http://localhost:8001/api/target/image-project?name=',
            loading: false,
            search: false,
            searchKey: "",
            SearchResult: "",
            search:false,
            title: this.$t('website.website-info'),
            items: [
                {
                text: "Dashboard",
                href: "/"
                },
                {
                text: this.$t('website.website-info'),
                active: true
                },
            ],
           
        }
    },
  methods:{
        searchWebsite(){
          this.loading = true,
          this.search = true;
          this.SearchResult = "";
          const data = {
            "website": this.searchKey,
          }
          WebsiteService.searchWebInfo(data)
          .then(response => {
                    this.SearchResult = response.data.output;
                    this.search = true;
                    this.loading = false;
                })
                .catch(err => {
                    console.log(err);
                    this.loading = false;
            });
        },
        
          saveWebsiteInfo(){
          this.loadingsave = true;
          var data = {
                  "domain_name": this.searchKey,
                  "visitors": this.SearchResult.visitors,
                  "ip_address": this.SearchResult.ip_address,
                  "link_ipv6_address": this.SearchResult.link_ipv6_address,
                  "ip_location": this.SearchResult.ip_location,
                  "ip_reverse_dns": this.SearchResult.ip_reverse_dns,
                  "hosting_company": this.SearchResult.hosting_company,
                  "hosting_ip_range": this.SearchResult.hosting_ip_range,
                  "hosting_address": this.SearchResult.hosting_address,
                  "hosting_country": this.SearchResult.hosting_country,
                  "hosting_phone": this.SearchResult.hosting_phone,
                  "hosting_website": this.SearchResult.hosting_website,
                  "cidr": this.SearchResult.cidr,
                  "hosting_cidr": this.SearchResult.hosting_cidr,          
                  }
                  // console.log(data);
          WebsiteService.createWebInfo(data)
          .then(response => {
                    this.SearchResult = "";
                    console.log(response.data.data);
                    this.search = true;
                    this.loading = false;
                    this.savePrivateWeb(response.data.data.id_web_info)
                })
                .catch(err => {
                    console.log(err);
                    this.loading = false;
            });
        },

          savePrivateWeb(idw){
          this.loadingsave = true;
          // console.log(this.SearchResult);
          var data = {
                    "id_target" : this.id,
                    "domain" : this.searchKey,
                    "id_ip" : "",
                    "id_web_info" : idw,
                    "id_whois" : "",
                    "id_web_service" : "",
                    "id_cms" : "",
                  }
                  console.log(data);
          WebsiteService.createPrivateWeb(data)
          .then(response => {
                    Swal.fire(this.$t('alert.alert-save'), '', 'success');
                    this.search = true;
                    this.loading = false;
                    this.$emit('reload');
                    // location.reload();
                })
                .catch(err => {
                    console.log(err);
                    this.loading = false;
            });
        },


        clearData(){
          this.SearchResult = "";
          this.searchKey = "";
        },
        
      formatDate(value){
          return moment(value).format("dddd, YYYY-MM-DD hh:mm");
      },
  },
    mounted(){
        this.totalRows = this.items.length;
    }
};
</script>

<style scoped>
.loading{
    padding-top:20%;
    padding-bottom:20%;
}
</style>